// Plain module (no 'use client') so BOTH the server Footer and the client
// FooterView can import these as real values. Importing a value from a
// 'use client' module into a server component yields an opaque client
// reference — spreading it silently produces {} (bit us: undefined hrefs).

export interface FooterLinks {
  anchorProblem: string
  anchorWhyHomie: string
  anchorSolution: string
  anchorFeatures: string
  anchorPricing: string
  anchorOurStory: string
  featureSharedCalendar: string
  featureFamilyTasks: string
  featureRoutines: string
  featureMealPlanning: string
  featureNotes: string
  featureInspiration: string
  featuresAll: string
  forBusyParents: string
  forCouples: string
  forAdhdFamilies: string
  forCoParenting: string
  forLargeFamilies: string
  forHomeschool: string
  postWritingThingsDown: string
  postCalmTech: string
  blogAll: string
  inspirationLibrary: string
  learn: string
  compareAppleCalendar: string
  compareCalendarsReaddle: string
  compareCozi: string
  compareFamcal: string
  compareFamilywall: string
  compareGoogleCalendar: string
  compareMaple: string
  compareSortifyd: string
  compareTimetree: string
  about: string
  forOrganisations: string
  legalPrivacy: string
  legalTerms: string
  legalSupport: string
}

export const EN_FOOTER_LINKS: FooterLinks = {
  anchorProblem: '/#problem',
  anchorWhyHomie: '/#why-homie',
  anchorSolution: '/#solution',
  anchorFeatures: '/#features',
  anchorPricing: '/#pricing',
  anchorOurStory: '/#our-story',
  featureSharedCalendar: '/features/shared-calendar',
  featureFamilyTasks: '/features/family-tasks',
  featureRoutines: '/features/routines',
  featureMealPlanning: '/features/meal-planning',
  featureNotes: '/features/notes',
  featureInspiration: '/features/inspiration',
  featuresAll: '/features',
  forBusyParents: '/for/busy-parents',
  forCouples: '/for/couples',
  forAdhdFamilies: '/for/adhd-families',
  forCoParenting: '/for/co-parenting',
  forLargeFamilies: '/for/large-families',
  forHomeschool: '/for/homeschool-families',
  postWritingThingsDown: '/blog/why-writing-things-down-reduces-stress',
  postCalmTech: '/blog/calm-technology-movement',
  blogAll: '/blog',
  inspirationLibrary: '/inspiration',
  learn: '/learn',
  compareAppleCalendar: '/compare/apple-calendar',
  compareCalendarsReaddle: '/compare/calendars-readdle',
  compareCozi: '/compare/cozi',
  compareFamcal: '/compare/famcal',
  compareFamilywall: '/compare/familywall',
  compareGoogleCalendar: '/compare/google-calendar',
  // Not a /compare/ page — the Maple switch page lives at its own route — but
  // it is the Maple comparison, so it sits with its siblings. Localized now
  // that content/no.ts exists, so the non-en footers override this with the
  // /no path rather than inheriting the English one.
  compareMaple: '/maple-alternative',
  compareSortifyd: '/compare/sortifyd',
  compareTimetree: '/compare/timetree',
  about: '/about',
  forOrganisations: '/partnerships',
  legalPrivacy: '/privacy',
  legalTerms: '/terms',
  legalSupport: '/support',
}
